import React, { useState, useEffect } from "react";
import InvoiceStyle from "./InvoiceStyle";
import { BsInfoCircle } from "react-icons/bs";
import Select from "react-select";
import { VscNewFile } from "react-icons/vsc";
import TableForm from "./TableForm";
import MnthVPt from "./Mnth_Vat_Rpt";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useSelectStyles } from "../../../hooks/useSelectStyles";

export default function OpenVatCalculator({ logo }) {
  const printRef = React.useRef();
  const styles = useSelectStyles();
  const [show, setShow] = useState(false);
  const [name, setName] = useState("");
  const [value, setValue] = useState(0);
  const [taxNum, setTaxNum] = useState("");
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("--");
  const [perTax, setPerTax] = useState(0);
  const [perTax2, setPerTax2] = useState(0);
  const [address, setAddress] = useState("");
  const [cityAddress, setCityAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [invoiceAddress, setInvoiceAddress] = useState("");
  const [dateInvoice, setDateInvoice] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState(0);
  const [startinvoiceNumber, setStartInvoiceNumber] = useState(0);
  const [companyName, setCompanyName] = useState("");
  const [companyNumber, setCompanyNumber] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerNumber, setCustomerNumber] = useState("");
  const [taxRate, setTaxRate] = useState(0);
  const [details, setDetails] = useState("");
  const [catalogNum, setCatalogNum] = useState("");
  const [invoiceDetails, setInvoiceDetails] = useState(" فاتورة ضريبية");
  const [catagory, setCatagory] = useState("إيرادات");
  // const [date1, setDate1] = useState('')
  // Date
  var curr = new Date();
  curr.setDate(curr.getDate());
  var date = curr.toISOString().substring(0, 10);
  // console.log("defaultDate:", date)
  const [date1, setDate1] = useState(date);
  const [date2, setDate2] = useState(date);
  const [price, setPrice] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [discountForProduct, setDiscountForProduct] = useState(0);
  const [exemptionAmount, setExemptionAmount] = useState(0);
  const [amount, setAmount] = useState(0);
  const [amounts, setAmounts] = useState(0);
  const [tax, setTax] = useState(0);
  const [isExemption, setIsExemption] = useState(false);
  const [totalAfTax, setTotalAfTax] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalAfDiscount, setTotalAfDiscount] = useState(0);
  const [list, setList] = useState([]);
  const [revenues, setRevenues] = useState([]);
  const [revenuesExempt, setRevenuesExempt] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [fixedExpenses, setFixedExpenses] = useState([]);
  const [information, setInformation] = useState("");
  // const [editorState, setEditorState] = useState(() =>
  //   EditorState.createEmpty()
  // );
  const [convertedContent, setConvertedContent] = useState();

  const [lastInvoiceNum, setLastInvoiceNum] = useState(0);
  const [invoiceCounter, setInvoiceCounter] = useState(0);
  const [isSearch, setIsSearch] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [isResult, setIsResult] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [filtered, setFiltered] = useState("");
  const [isAddContact, setIsAddContact] = useState(true);
  const [data, setData] = useState([]);
  const [coData, setCoData] = useState();
  const [s, setS] = useState(0); // المبيعات / شامل
  const [a, setA] = useState(0); // المبيعات / معفى
  const [capex, setCapex] = useState(0); // المصاريف / أصول ثابتة
  const [exp, setExp] = useState(0); // المصاريف العادية / شامل

  const [NOTE, setNOTE] = useState("");
  const savedHDetails = localStorage.getItem("headerDetails")
    ? JSON.parse(localStorage.getItem("headerDetails"))
    : [];
  const [headerDetails, setHDeatils] = useState(savedHDetails);

  useEffect(() => {
    let headDetails = {
      companyName,
      companyNumber,
      month,
      year,
      customerName,
      taxRate,
      NOTE,
    };

    setHDeatils(headDetails);
  }, [companyName, companyNumber, month, year, customerName, taxRate, NOTE]);
  // console.log("headerDetails : ", headerDetails)
  // Add To local Storage
  useEffect(() => {
    localStorage.setItem("headerDetails", JSON.stringify(headerDetails));
  }, [headerDetails]);
  useEffect(() => {
    const detailss = JSON.parse(localStorage.getItem("headerDetails"));
    if (detailss) {
      setHDeatils(detailss);
      setCompanyName(detailss.companyName);
      setCompanyNumber(detailss.companyNumber);
      setMonth(detailss.month);
      setYear(detailss.year);
      setCustomerName(detailss.customerName);
      setTaxRate(detailss.taxRate);
      setNOTE(detailss.NOTE);
    }
  }, []);

  //MODAL
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  //MODAL
  const [showMssg, setShowMssg] = useState(false);
  const handleCloseMssg = () => setShowMssg(false);
  const handleShowMssg = () => setShowMssg(true);
  //MODAL_Calc
  const [showCalc, setshowCalc] = useState(false);
  const handleCloseCalc = () => setshowCalc(false);
  const handleShowCalc = () => setshowCalc(true);
  // ModalExit
  const [showExit, setShowExit] = useState(false);
  const handleShowExit = () => setShowExit(true);
  const handleCloseExit = () => setShowExit(false);
  // LANGUAGE
  const [lang, setLang] = useState("");
  const [DEAR, setDEAR] = useState("");
  const [TAXNUMBER, setTAXNUMBER] = useState("");
  const [DATE, setDATE] = useState("");
  const [PAYUNTIL, setPAYUNTIL] = useState("");
  const [TOTAL, setTOTAL] = useState("");
  const [TAXINVOICENUMBER, setTAXINVOICENUMBER] = useState("");

  const [SIGNATURE, setSIGNATURE] = useState("");
  const [ORIGINAL, setORIGINAL] = useState("");
  const [filesvalues, setFilesValues] = useState([]);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [triggerUpload, setTriggerUpload] = useState(false);
  const [resetSearch, setResetSearch] = useState(false);
  const { fileSize, lastModified } = formatFileInfo(uploadedFile || "");
  const [fileValue, setFileValue] = useState("");
  const handleFileUpload = (file) => {
    // console.log("File received in parent:", file);
    setUploadedFile(file);
  };
  const triggerChildFileUpload = () => {
    setTriggerUpload(true);
    setTimeout(() => setTriggerUpload(false), 100); // Reset after trigger
  };

  function formatFileInfo(file) {
    const sizeInKB = file.size / 1024;
    const readableSize =
      sizeInKB < 1024
        ? `${sizeInKB.toFixed(2)} KB`
        : `${(sizeInKB / 1024).toFixed(2)} MB`;

    const date = new Date(file.lastModified);
    const options = {
      day: "2-digit",
      month: "short",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    };
    const readableDate = date.toLocaleString("en-US", options); // Or use 'ar-EG', 'he-IL' etc. for localization

    return {
      fileSize: readableSize,
      lastModified: readableDate,
    };
  }
  const handleClear = () => {
    localStorage.clear();

    window.location.reload(true);
  };

  let revenuestot = 0;
  const revenuesTotal = revenues
    ? revenues.map(
        (value) => (revenuestot = revenuestot + value.price * 1)

        // console.log("revs are: ", value.price)
      )
    : 0;
  //console.log("REVS are : ", revenues)
  let revenuesExempttot = 0;

  const revenuesExemptTotal = revenuesExempt
    ? revenuesExempt.map(
        (value) =>
          // console.log("EXEMPTTTTTTTT: ",value.price * 1)
          (revenuesExempttot = revenuesExempttot + value.price * 1)
      )
    : 0;
  //console.log("revenuesExempt are : ", revenuesExempt)

  let expensestot = 0;
  const expensesTotal = expenses
    ? expenses.map((value) => (expensestot = expensestot + value.price * 1))
    : 0;
  let fixedExpensestot = 0;
  const fixedExpensesTotal = fixedExpenses
    ? fixedExpenses.map(
        (value) => (fixedExpensestot = fixedExpensestot + value.price * 1)
      )
    : 0;

  //console.log("fixedExpenses are : ", fixedExpenses)

  const handleDownloadPdf = async () => {
    // handleSubmit()
    console.log("new invoice created !!");
    console.log(" here ");
  };

  //-------------------start rendering--------------------------
  const monthOptions = [
    { value: "--", label: "--" },
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "1-2", label: "1 - 2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "3-4", label: "3 - 4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
    { value: "5-6", label: "5 - 6" },
    { value: "7", label: "7" },
    { value: "8", label: "8" },
    { value: "7-8", label: "7 - 8" },
    { value: "9", label: "9" },
    { value: "10", label: "10" },
    { value: "9-10", label: "9 - 10" },
    { value: "11", label: "11" },
    { value: "12", label: "12" },
    { value: "11-12", label: "11 - 12" },
  ];

  return (
    <div className="">
      <div className="">
        <div className="">
          <div className="page-header">
            <div className="row card">
              <div className="card-header text-center p-3 mb-3">
                {invoiceNumber > 0 && (
                  <h1 className="page-title text-center text-primary fw-bold">
                    JV رقم{" "}
                    <span className="text-success">{invoiceNumber + "#"}</span>{" "}
                  </h1>
                )}
                {invoiceNumber == 0 && (
                  <h1 className="page-title text-center  text-primary">
                    جرب BookBot اليوم , دفاترك ستشكرك
                  </h1>
                )}
              </div>
            </div>
          </div>

          {show ? (
            <div className="row ">
              <InvoiceStyle
                lang={lang}
                DEAR={DEAR}
                TAXNUMBER={TAXNUMBER}
                TAXINVOICENUMBER={TAXINVOICENUMBER}
                DATE={DATE}
                PAYUNTIL={PAYUNTIL}
                TOTAL={TOTAL}
                NOTE={NOTE}
                SIGNATURE={SIGNATURE}
                ORIGINAL={ORIGINAL}
                name={name}
                printRef={printRef}
                taxNum={taxNum}
                address={address}
                cityAddress={cityAddress}
                phone={phone}
                companyName={companyName}
                companyNumber={companyNumber}
                customerName={customerName}
                customerNumber={customerNumber}
                year={year}
                month={month}
                logo={logo}
                coData={coData}
                revenues={revenues}
                setRevenues={setRevenues}
                revenuesExempt={revenuesExempt}
                setRevenuesExempt={setRevenuesExempt}
                expenses={expenses}
                setExpenses={setExpenses}
                fixedExpenses={fixedExpenses}
                setFixedExpenses={setFixedExpenses}
                list={list}
                amounts={amounts}
                tax={tax}
                discount={discount}
                total={total}
                information={information}
                totalAfDiscount={totalAfDiscount}
                perTax={perTax}
                dueDate={dueDate}
                totalAfTax={totalAfTax}
                exemptionAmount={exemptionAmount}
                headerDetails={headerDetails}
                handleDownloadPdf={handleDownloadPdf}
                // handleSubmit={handleSubmit}

                show={show}
                setShow={setShow}
                showModal={showModal2}
                setShowModal={setShowModal2}
                invoiceNumber={invoiceNumber}
                dateInvoice={dateInvoice}
              />
            </div>
          ) : (
            ////////////////////////////////////// ENGLISH INVOICE ////////////////////////

            ////////////////////////// form start here/////////////////////////////////////

            <>
              {/* Page Content */}

              {/* ========================= JV_SECTION======================= */}
              <div className=" row filter-row  mt-4 mb-4 ">
                <div className="col-sm-6 col-md-4 col-lg-4 col-xl-2 col-12">
                  <div className="input-block form-focus ">
                    <label>
                      اسم الشركة <span className="text-danger">*</span>
                    </label>

                    <input
                      className="form-control"
                      type="name"
                      onChange={(e) => {
                        // nam === "زبون  طيار" || name == undefined ? "name" :  setName(e.target.value)
                        setCompanyName(e.target.value);
                      }}
                      value={companyName}
                      required
                    />
                  </div>
                </div>

                <div className="col-sm-6 col-md-4 col-lg-4 col-xl-2 col-12">
                  <div className="input-block form-focus ">
                    <label>
                      رقم الشركة <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      //  onChange={taxNumChange}
                      onChange={(e) => setCompanyNumber(e.target.value)}
                      value={companyNumber}
                      required
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-4 col-xl-2 col-12">
                  <div className="input-block form-focus ">
                    <label>نسبة سلفيات ضريبة الدخل </label>
                    <input
                      className="form-control "
                      type="text"
                      onChange={(e) => setTaxRate(e.target.value)}
                      value={taxRate}
                    />
                  </div>
                </div>

                <div className="col-sm-6 col-md-4 col-lg-4 col-xl-2 col-12">
                  <div className="input-block form-focus select-focus">
                    <label>فترة الكشف </label>
                    <Select
                      className="tax-select test"
                      options={monthOptions}
                      value={monthOptions.find(
                        (option) => option.value === month
                      )}
                      onChange={(selectedOption) =>
                        setMonth(selectedOption.value)
                      }
                      placeholder="בחר חודש"
                      styles={styles}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-4 col-xl-2 col-12">
                  <div className="input-block form-focus ">
                    <label>السنة </label>
                    <input
                      className="form-control"
                      type="text"
                      value={year}
                      //  onChange={emailChange}
                      onChange={(e) => setYear(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className=" col-md-12 content container-fluid ">
                <div className="row">
                  <div>
                    {/* ---------------- Table Form --------------------- */}
                    <TableForm
                      month={month}
                      setMonth={setMonth}
                      details={details}
                      setDetails={setDetails}
                      headerDetails={headerDetails}
                      setHDeatils={setHDeatils}
                      quantity={quantity}
                      setQuantity={setQuantity}
                      price={price}
                      setPrice={setPrice}
                      amount={amount}
                      setAmount={setAmount}
                      total={total}
                      setTotal={setTotal}
                      totalAfDiscount={totalAfDiscount}
                      setTotalAfDiscount={setTotalAfDiscount}
                      totalAfTax={totalAfTax}
                      setTotalAfTax={setTotalAfTax}
                      catalogNum={catalogNum}
                      setInvoiceDetails={setInvoiceDetails}
                      invoiceDetails={invoiceDetails}
                      setCatagory={setCatagory}
                      catagory={catagory}
                      date1={date1}
                      date2={date2}
                      setDate1={setDate1}
                      setDate2={setDate2}
                      setCatalogNum={setCatalogNum}
                      perTax={perTax}
                      setPerTax={setPerTax}
                      tax={tax}
                      setTax={setTax}
                      discountForProduct={discountForProduct}
                      setDiscountForProduct={setDiscountForProduct}
                      amounts={amounts}
                      setAmounts={setAmounts}
                      discount={discount}
                      setDiscount={setDiscount}
                      isExemption={isExemption}
                      setIsExemption={setIsExemption}
                      exemptionAmount={exemptionAmount}
                      setExemptionAmount={setExemptionAmount}
                      list={list}
                      setList={setList}
                      revenues={revenues}
                      setRevenues={setRevenues}
                      revenuesExempt={revenuesExempt}
                      setRevenuesExempt={setRevenuesExempt}
                      expenses={expenses}
                      setExpenses={setExpenses}
                      fixedExpenses={fixedExpenses}
                      setFixedExpenses={setFixedExpenses}
                      companyName={companyName}
                      setCompanyName={setCompanyName}
                    />
                  </div>
                </div>

                <Modal show={showMssg} onHide={handleCloseMssg}>
                  <Modal.Header closeButton>
                    {/* <Modal.Title>Modal heading</Modal.Title> */}
                  </Modal.Header>
                  <Modal.Body>
                    يرجى تعبئة الحقول المطلوبة, لايمكنك إنشاء قيد مالي
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseMssg}>
                      إغلاق
                    </Button>
                  </Modal.Footer>
                </Modal>
                <Modal show={showExit} onHide={handleCloseExit}>
                  <Modal.Header closeButton>
                    {/* <Modal.Title>Modal heading</Modal.Title> */}
                  </Modal.Header>
                  <Modal.Body>
                    هل تريد حذف المعلومات و فتح ملف جديد ؟{" "}
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseExit}>
                      لا
                    </Button>
                    <Button variant="primary" onClick={handleClear}>
                      نعم
                    </Button>
                  </Modal.Footer>
                </Modal>
                <div className="submit-section"></div>
                {/* ===========================JV_SEction======================= */}

                <MnthVPt
                  s={revenuestot}
                  setS={setS}
                  a={revenuesExempttot}
                  setA={setA}
                  exp={expensestot}
                  setExp={setExp}
                  capex={fixedExpensestot}
                  setCapex={setCapex}
                  companyName={companyName}
                  companyNumber={companyNumber}
                  year={year}
                  month={month}
                  taxRate={taxRate}
                  setMonth={setMonth}
                  customerName={customerName}
                  customerNumber={customerNumber}
                  setCompanyName={setCompanyName}
                  setCompanyNumber={setCompanyNumber}
                  setCustomerName={setCustomerName}
                  setCustomerNumber={setCustomerNumber}
                  setYear={setYear}
                  lang={lang}
                  DEAR={DEAR}
                  TAXNUMBER={TAXNUMBER}
                  TAXINVOICENUMBER={TAXINVOICENUMBER}
                  DATE={DATE}
                  PAYUNTIL={PAYUNTIL}
                  TOTAL={TOTAL}
                  NOTE={NOTE}
                  SIGNATURE={SIGNATURE}
                  ORIGINAL={ORIGINAL}
                  name={name}
                  printRef={printRef}
                  taxNum={taxNum}
                  address={address}
                  cityAddress={cityAddress}
                  phone={phone}
                  logo={logo}
                  coData={coData}
                  revenues={revenues}
                  setRevenues={setRevenues}
                  revenuesExempt={revenuesExempt}
                  setRevenuesExempt={setRevenuesExempt}
                  expenses={expenses}
                  setExpenses={setExpenses}
                  fixedExpenses={fixedExpenses}
                  setFixedExpenses={setFixedExpenses}
                  list={list}
                  amounts={amounts}
                  tax={tax}
                  discount={discount}
                  total={total}
                  information={information}
                  totalAfDiscount={totalAfDiscount}
                  perTax={perTax}
                  dueDate={dueDate}
                  totalAfTax={totalAfTax}
                  exemptionAmount={exemptionAmount}
                  headerDetails={headerDetails}
                  handleDownloadPdf={handleDownloadPdf}
                  // handleSubmit={handleSubmit}

                  show={show}
                  setShow={setShow}
                  showModal={showModal2}
                  setShowModal={setShowModal2}
                  invoiceNumber={invoiceNumber}
                  dateInvoice={dateInvoice}
                />
              </div>

              <div className="row   card">
                <div className="card-header">
                  <h3 className="card-title d-flex justify-content-between mt-2 pt-4">
                    <span className="text-primary   fw-bold">
                      <BsInfoCircle size={23} className="text-primary ms-3" />
                      كل المعلومات سوف تحفظ على متصفحك الخاص ويمكنك الوصول اليها
                      بمجرد الدخول الى صفحة الحاسبة واذا اردت حذفها واحتساب جديد
                      اضغط حذف
                    </span>
                    <span
                      className="  btn btn-primary text-center pe-4 ps-4"
                      onClick={handleShowExit}
                    >
                      <VscNewFile size={25} /> <span>ملف جديد</span>
                    </span>
                  </h3>
                </div>
              </div>

              {/* /Page Content */}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
